/**
 * Form alanlarinin bir kismi gecmiste secenek nesnesinin tamami olarak
 * kaydedilmis ({ code, label } gibi). Bu kayitlar ciktilarda ham JSON olarak
 * goruntuleniyordu (ornek: T-Sonda raporunda Fizyografya alani).
 *
 * plainValue, hem duz metni hem de eski nesne/JSON bicimini okunabilir metne
 * cevirir. Yeni kayitlar zaten duz metin oldugu icin onlara dokunmaz.
 */
export function plainValue(v) {
  if (v === null || v === undefined) return "";
  if (typeof v === "number" || typeof v === "boolean") return v;

  if (typeof v === "string") {
    const s = v.trim();
    // JSON metni olarak saklanmis nesneler
    if (s.startsWith("{") && s.endsWith("}")) {
      try {
        return plainValue(JSON.parse(s));
      } catch (e) {
        return v;
      }
    }
    return v;
  }

  if (Array.isArray(v)) return v.map(plainValue).filter(Boolean).join(", ");

  if (typeof v === "object") {
    return v.label || v.name || v.code || v.value || "";
  }

  return String(v);
}

export default plainValue;
